import React from "react";
import "./Badge.scss";
import { OrderStatus } from "types/OrdersTypes";

const Badge: React.FC<{ status: OrderStatus }> = ({ status }) => {
  if (!status) {
    return null;
  }
  const getBadgeClass = (type: OrderStatus) => {
    switch (type) {
      case OrderStatus.NowaProsba:
        return "badge--new";
      case OrderStatus.PrzedstawionePrzewoznikom24h:
        return "badge--przedstawiony";
      case OrderStatus.PrzedstawionePrzewoznikomNaDzisiaj:
        return "badge--przedstawiony";
      case OrderStatus.Podjete:
        return "badge--podjete";
      case OrderStatus.PrzekazaneDoWysylki:
        return "badge--przekazane";
      case OrderStatus.Awizowane:
        return "badge--awizowane";
      case OrderStatus.DoZaksiegowaniaSAP:
        return "badge--do-zaksiegowania";
      case OrderStatus.Zaksiegowane:
        return "badge--zaksiegowane";
      case OrderStatus.Anulowane:
        return "badge--anulowane";
      default:
        return "";
    }
  };

  const getBadgeLabel = (type: OrderStatus) => {
    switch (type) {
      case OrderStatus.NowaProsba:
        return "Nowy";
      case OrderStatus.PrzedstawionePrzewoznikom24h:
        return "Przedstawiony";
      case OrderStatus.PrzedstawionePrzewoznikomNaDzisiaj:
        return "Przedstawiony";
      case OrderStatus.Podjete:
        return "Podjęte";
      case OrderStatus.PrzekazaneDoWysylki:
        return "Przekazane do Wysyłki";
      case OrderStatus.Awizowane:
        return "Awizowane";
      case OrderStatus.DoZaksiegowaniaSAP:
        return "Do Zaksięgowania w SAP";
      case OrderStatus.Zaksiegowane:
        return "Zaksięgowane w SAP";
      case OrderStatus.Anulowane:
        return "Anulowane";
      default:
        return "";
    }
  };

  return (
    <span className={`badge ${getBadgeClass(status)}`}>
      {getBadgeLabel(status)}
      <span className="badge-icon"></span>
    </span>
  );
};

export default Badge;
